import { createSelector, defaultMemoize } from 'reselect';

import { propertiesSelector } from './properties';
import { subselect } from './root';

const memoizedIsRatingImage = defaultMemoize(
  (rating, ratings) => !!ratings[rating] && !!ratings[rating].image,
);

const isRatingImageUseSelector = createSelector([propertiesSelector], ({ data = {} }) => (rating) =>
  memoizedIsRatingImage(rating, data),
);

export const isRatingImageSelector = subselect(isRatingImageUseSelector);
